export default {
  title: {
    index: 'Job Board Point Management',
    history: 'Point Change History'
  },
  menu: {
    index: 'Job Board Point Management',
    history: 'Point Change History'
  },
  label: {
    companyName: 'Company Name',
    companyID: 'Company ID',
    allocatePoints: 'Balance',
    purchasedJobsCount: 'Number of jobs purchased',
    postingJobs: 'Posted Points',
    surplusPoints: 'Surplus Points',
    activeJobs: 'Active job(s)',
    surplusPointsTitle: '{companyName} points balance:',
    purchaseDate: 'Date',
    job: 'Job',
    activity: 'Activity',
    points: 'Points',
    note: 'Note',
    purchased: 'Purchased',
    allocated: 'Allocated',
    all: 'All'
  },
  placeholder: {
    pointsInput: 'Please enter',
    notes: 'Remarks (optional)'
  },
  btn: {
  },
  message: {
    pointsRequired: 'The points must be greater than 0!',
    maxCountGatherZero: 'The count must be greater than or equal to 0!',
    pointsNotEnough: 'Oops! There is not enough 51job points, please contact your admin or account manager at AJINGA for support',
    countsNotEnough: 'Oops! Seems you have already posted {count} jobs to LinkedIn and there is no more vacancy. For any inquiries, please contact your admin or account manager at AJINGA for support',
    pointsLessThanMillion: 'The points must be less than one million'
  }
}
